import { gql } from "@apollo/client";

export const GridViewClient = gql`
    query GridViewClient ($id: ID!) {
        gridView (id: $id) {
            id
            client {
                id
            }
        }
    }
`;
